import Checkbox from "@/common/elements/InputElements/CheckBox";
import Select from "@/common/elements/InputElements/Select";
import TextField from "@/common/elements/InputElements/TextField";
import { IntakeSectionHeader } from "@/common/styles";
import { Col, Form, Row } from "antd";
import { FormContainer } from "../InmateDetails/styles";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import {
  getOptionsFromRefList,
  isNonEmptyVariable,
} from "@/util/common_function";
import CommonDatePicker from "@/common/elements/DatePicker";
import { useSelector } from "react-redux";

const SentencingInformation = ({
  releaseDateOverridden,
  sentenceConsecutive,
  sentenceLength,
}) => {
  const { bookingsFieldsEnabled } = useSelector(
    (state) => state?.bookings
  );
  const fullSearch = useSelector(state => state.fullSearch);
  return (
    <>
      <IntakeSectionHeader>
        <span>Sentencing Information</span>
      </IntakeSectionHeader>
      <FormContainer>
        <Row gutter={16}>
          <Col span={8}>
            <FormItem
              name="sentence"
              label="Sentence Description"
              layout="vertical"
            >
              <TextField disabled={!bookingsFieldsEnabled} />
            </FormItem>
          </Col>
          <Col span={8}>
            <FormItem
              name="sentenceDate"
              label="Sentence Date"
              layout="vertical"
            >
              <CommonDatePicker
                placeholder="MM/DD/YYYY"
                format="MM/DD/YYYY"
                showTime={false}
                disabled={!bookingsFieldsEnabled}
              />
            </FormItem>
          </Col>
          <Col span={8}>
            <FormItem
              name="sentencingCountyID"
              label="Sentencing County"
              layout="vertical"
            >
              <Select
                options={getOptionsFromRefList(
                  "Sentencing_County",
                  false,
                  false,
                  true
                )}
                placeholder="Sentencing County"
                showSearch={true}
                variant="outlined"
                disabled={!bookingsFieldsEnabled}
              />
            </FormItem>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={5} style={{ display: "flex", alignItems: "center" }}>
            <FormItem
              name="sentenceConsecutive"
              valuePropName="checked"
              label="Sentence Consecutive?"
              layout="vertical"
            >
              <Checkbox style={{ flex: 1 }} disabled={!bookingsFieldsEnabled} />
            </FormItem>
          </Col>

          <Col span={8}>
            <FormItem
              name="sentenceConsecutiveTo"
              label="To (Sequence #)"
              layout="vertical"
            >
              <TextField disabled={!bookingsFieldsEnabled || (!sentenceConsecutive && !fullSearch)} />
            </FormItem>
          </Col>

          <Col span={8}>
            <FormItem
              name="sentenceStartDateTime"
              label="Sentence Start Date & Time"
              layout="vertical"
            >
              <CommonDatePicker
                placeholder="MM/DD/YYYY HH:mm"
                format="MM/DD/YYYY HH:mm"
                disabled={sentenceConsecutive || !bookingsFieldsEnabled}
              />
            </FormItem>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={6}>
            <FormItem
              name="sentenceLength"
              label="Sentence Length"
              layout="vertical"
            >
              <TextField type="number" disabled={!bookingsFieldsEnabled} />
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem
              name="stayedOrSuspendedDays"
              label="Stayed/Suspended Days"
              layout="vertical"
            >
              <TextField type="number" disabled={!bookingsFieldsEnabled} />
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem
              name="treatmentDays"
              label="Treatment Days"
              layout="vertical"
            >
              <TextField type="number" disabled={!bookingsFieldsEnabled} />
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem
              name="creditDaysServed"
              label="Credit For Days Served"
              layout="vertical"
            >
              <TextField type="number" disabled={!bookingsFieldsEnabled} />
            </FormItem>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={8}>
            <FormItem
              name="goodTimeDays"
              label="Good Time Days"
              layout="vertical"
            >
              <TextField type="number" disabled={!bookingsFieldsEnabled || !fullSearch} />
            </FormItem>
          </Col>
          <Col span={8}>
            <FormItem
              name="goodTimeDaysLost"
              label="Lost Good TIme Days"
              layout="vertical"
            >
              <TextField
                type="number"
                disabled={!bookingsFieldsEnabled ||
                  (isNonEmptyVariable(sentenceLength) &&
                  parseInt(sentenceLength) < 6
                    ? true
                    : false)
                }
              />
            </FormItem>
          </Col>
          <Col span={8}>
            <FormItem
              name="totalDaysForThisCharge"
              label="Total Days for this Charge"
              layout="vertical"
            >
              <TextField type="number" disabled={!bookingsFieldsEnabled || !fullSearch} />
            </FormItem>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={8}>
            <FormItem name="sentenceEndDate" label="End Date" layout="vertical">
              <CommonDatePicker
                placeholder="MM/DD/YYYY"
                format="MM/DD/YYYY"
                showTime={false}
                disabled={!fullSearch || !bookingsFieldsEnabled}
              />
            </FormItem>
          </Col>
          <Col span={6} style={{ display: "flex", alignItems: "center" }}>
            <FormItem
              name="releaseDateOverridden"
              valuePropName="checked"
              label="Override Release Date?"
              layout="vertical"
            >
              <Checkbox style={{ flex: 1 }} disabled={!bookingsFieldsEnabled} />
            </FormItem>
          </Col>
          <Col span={8}>
            <FormItem
              name="scheduledReleaseDateTime"
              label="Scheduled Release Date & Time"
              layout="vertical"
            >
              <CommonDatePicker
                placeholder="MM/DD/YYYY HH:mm"
                format="MM/DD/YYYY HH:mm"
                disabled={(!releaseDateOverridden && !fullSearch) || !bookingsFieldsEnabled}
              />
            </FormItem>
          </Col>
        </Row>
      </FormContainer>
    </>
  );
};

export default SentencingInformation;
